export const isEmpty = (val: any) => {
    if (val instanceof Object) {
        return Object.keys(val).length === 0
    }
    return val === null || val === '' || val === undefined
}
